import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import MessagingActions from '../../../actions/MessagingActions';
import { getGlobalMessaging } from '../../../selectors/MessagingSelector';
import BatchActionsList from '../../../components/shared/BatchActions/BatchActionsList';

export class BatchActionsListContainer extends BcReactComponent {
  render() {
    return (
      <BatchActionsList
        actionIsLoading={this.props.actionIsLoading}
        list={this.props.list}
        pageNumber={this.props.pageNumber}
        pageLimit={this.props.pageLimit}
        totalItems={this.props.totalItems}
        globalMessaging={this.props.globalMessaging}
        renderActionsMenu={this.props.renderActionsMenu}
        messagingActions={this.props.messagingActions}>
        {this.props.children}
      </BatchActionsList>
    );
  }
}

const mapStateToProps = (state) => ({
  globalMessaging: getGlobalMessaging(state)
});

const mapDispatchToProps = dispatch => ({
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

BatchActionsListContainer.propTypes = {
  actionIsLoading: PropTypes.bool,
  list: ImmutablePropTypes.list.isRequired,
  pageNumber: PropTypes.number,
  pageLimit: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  renderActionsMenu: PropTypes.func.isRequired,
  globalMessaging: ImmutablePropTypes.map,
  children: PropTypes.func.isRequired,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchActionsListContainer);



// WEBPACK FOOTER //
// ./app/containers/shared/BatchActions/BatchActionsListContainer.jsx